import { useAuth } from '@/auth/useAuth'
import type { UserCompanyRoleSetViewDto } from '@/types/user'
import { isConsoleEnabled } from '../flag'

/** An admin role on this company itself, not on the company that manages it: what opens its Admin, and what the Customers list offers a way in on. */
export function holdsCompanyAdminRole(roleSets: UserCompanyRoleSetViewDto[] | null | undefined, clientCompanyId: string): boolean {
  return roleSets?.some(role => role.ClientCompanyId === clientCompanyId && (role.IsAdmin || role.CompanyRoles?.includes('Admin'))) ?? false
}

export type CompanyAdminAccess = 'checking' | 'disabled' | 'none' | 'allowed'

export function useCompanyAdminAccess(clientCompanyId: string): CompanyAdminAccess {
  const { isLoading, userCompanyRoleSets } = useAuth()
  if (!isConsoleEnabled()) return 'disabled'
  if (isLoading) return 'checking'
  return holdsCompanyAdminRole(userCompanyRoleSets, clientCompanyId) ? 'allowed' : 'none'
}
